import { lazy } from 'react';
import { retry } from '../../../config/utils';

const Personal1 = lazy(() => retry(() => import(/* webpackChunkName: "Personal1" */ "./Personal1")));

export default Personal1;